<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <OwnerSelect v-model="selectedOwnerIds" :items="eligibleOwners" :loading="loadingOwners" :error-messages="errorMessage" :multiple="true" :show-pending-payouts="true" label="Select owners" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { router } from '@inertiajs/vue3';
import type { FormOptions } from '@shared/types/Form';
import { usePayoutEventRepository } from '@app/purchase/bundle/repositories/usePayoutEventRepository.ts';
import type { EligibleOwner } from '@app/purchase/bundle/routes/routes';
import OwnerSelect from '@app/land-hold/owner/components/molecules/OwnerSelect.vue';

const props = defineProps({
    bundleId: {
        type: String,
        required: true,
    },
});

const selectedOwnerIds = ref<string[]>([]);
const errorMessage = ref('');

const { data: eligibleOwnersResponse, processing: loadingOwners } = usePayoutEventRepository().query.eligibleOwners(props.bundleId);
const eligibleOwners = computed<EligibleOwner[]>(() => eligibleOwnersResponse.value?.data ?? []);

function execute(options: FormOptions): void {
    if (selectedOwnerIds.value.length === 0) {
        errorMessage.value = 'Please select at least one owner.';
        return;
    }

    errorMessage.value = '';
    options.onStart?.();

    router.post(
        route('bundles.add-owners', { id: props.bundleId }),
        { owner_ids: selectedOwnerIds.value },
        {
            onSuccess: (page) => {
                options.onSuccess?.(page);
            },
            onError: (errors) => {
                errorMessage.value = Object.values(errors).flat().join(', ') || 'Failed to add owners.';
            },
            onFinish: (visit) => {
                options.onFinish?.(visit);
            },
        },
    );
}

useInjectSubmitForm(execute);
</script>
